import getMenuItemsInMenu from './getMenuItemsInMenu';
export default getMenuItemsInMenu;
